<button mat-flat-button [matMenuTriggerFor]="menu" [disableRipple]="true" class="pr-0">
	<span
		*ngIf="helpersService.isOpenFiberUser || helpersService.isFastwebUser || helpersService.isWindTreUser"
		matBadge="{{ notifications.count_new }}"
		matBadgePosition="before"
		matBadgeColor="accent"
		matBadgeSize="small"
		[matBadgeHidden]="notifications.count_new < 1"
		class="d-flex align-items-center"
	>
		<i class="fas fa-user-circle icon-user mr-1"></i>
		<i class="fas fa-sort-down"></i>
	</span>
	<span
		*ngIf="!helpersService.isOpenFiberUser && !helpersService.isFastwebUser && !helpersService.isWindTreUser"
		class="d-flex align-items-center"
	>
		<i class="fas fa-user-circle icon-user mr-1"></i>
		<i class="fas fa-sort-down"></i>
	</span>
</button>
<mat-menu #menu="matMenu">
	<button
		mat-menu-item
		[class.d-none]="
			!helpersService.isOpenFiberUser && !helpersService.isFastwebUser && !helpersService.isWindTreUser
		"
		(click)="router.navigateByUrl('/notification-area')"
	>
		Notification
	</button>
	<button
		mat-menu-item
		[class.d-none]="
			!helpersService.isOpenFiberUser && !helpersService.isFastwebUser && !helpersService.isWindTreUser
		"
		(click)="router.navigateByUrl('/download-area')"
	>
		Download area
	</button>
	<button mat-menu-item (click)="router.navigateByUrl('/report-error?authorized=true')">Open an Issue</button>
	<button mat-menu-item (click)="authService.logout()">Logout</button>
</mat-menu>
